export const LAYOVER_PROTECTED_MISSED_CONNECTION_GUARANTEE =
  "Layover protected by our <span>missed connection guarantee</span>";
/** @see https://hopper-jira.atlassian.net/browse/COTA-1093 */
export const LAYOVER_PROTECTED_MISSED_CONNECTION_REBOOKING =
    "Layover protected by our <span>missed connection rebooking</span>";
export const SELF_CHECKIN =
  "You are required to claim and re-check baggage during this layover.";
export const LEARN_MORE = "Learn more";
